var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationtypeLocalGrowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_di_10519_44070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 24.668C44 35.7137 27.017 51.3346 24 51.3346C20.983 51.3346 4 35.7137 4 24.668C4 13.6223 12.9543 4.66797 24 4.66797C35.0457 4.66797 44 13.6223 44 24.668Z",
    fill: "#C0ADCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24Z",
    fill: "#E6DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 16H20C22.5938 16 24.75 18.1562 24.75 20.75V24C24.75 24.4375 24.4062 24.75 24 24.75C23.5625 24.75 23.25 24.4375 23.25 24V21.5H21.875C19.4375 21.5 17.5 19.5625 17.5 17.125C17.5 16.5 18 16 18.5938 16ZM20 17.5H19C19.1875 18.9375 20.4062 20 21.875 20H23.1562C22.8125 18.5938 21.5312 17.5 20 17.5ZM20.1562 27.2188L17.6562 28.875C17.5312 28.9688 17.375 29 17.25 29H15.75C15.3125 29 15 28.6875 15 28.25C15 27.8438 15.3125 27.5 15.75 27.5H17L19.3125 25.9688C19.7812 25.6875 20.3125 25.5 20.8438 25.5H25.75C26.8438 25.5 27.75 26.4062 27.75 27.5C27.75 27.5312 27.75 27.5625 27.75 27.5625L29.75 26.3125C30.0938 26.125 30.4688 26 30.875 26H31.0938C32.1562 26 33 26.8438 33 27.9062C33 28.5312 32.6562 29.125 32.125 29.4688L29.125 31.4062C28.5312 31.8125 27.8125 32 27.0938 32H15.75C15.3125 32 15 31.6875 15 31.25C15 30.8438 15.3125 30.5 15.75 30.5H27.0938C27.5312 30.5 27.9688 30.375 28.3125 30.1562L31.3125 28.2188C31.4375 28.1562 31.5 28.0312 31.5 27.9062C31.5 27.6875 31.3125 27.5 31.0938 27.5H30.875C30.75 27.5 30.6562 27.5312 30.5625 27.5938L27.625 29.4062C27.5 29.4688 27.375 29.5 27.25 29.5H25.75H25H23C22.5625 29.5 22.25 29.1875 22.25 28.75C22.25 28.3438 22.5625 28 23 28H25H25.75C26 28 26.25 27.7812 26.25 27.5C26.25 27.25 26 27 25.75 27H20.8438C20.5938 27 20.3438 27.0938 20.1562 27.2188ZM26.0938 21.5H25.75V20.75C25.75 20.5 25.7188 20.25 25.6875 20H26.0938C27.5625 20 28.7812 18.9375 28.9688 17.5H28C26.9375 17.5 26 18.0312 25.4062 18.8125C25.2188 18.2812 24.9688 17.8125 24.6562 17.375C25.5 16.5312 26.6875 16 28 16H29.375C30 16 30.5 16.5 30.5 17.125C30.5 19.5625 28.5312 21.5 26.0938 21.5Z",
    fill: "#765889"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10519_44070",
    x: -2,
    y: -1,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10519_44070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10519_44070",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10519_44070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationtypeLocalGrowers);
export default __webpack_public_path__ + "static/media/organizationtype-local_growers.104a7d015f9c1c5136b5f48b58048822.svg";
export { ForwardRef as ReactComponent };